import * as Yup from "yup";

import { Strings } from "@app/constants";
import { fieldRequiredValidation, emailValidation } from "@app/utils";

export const addNewProductSchema = Yup.object()
  .shape({
    name: Yup.string().required(
      Strings.validation.fieldRequired(Strings.dashboard.name)
    ),
    description: Yup.string().required(
      Strings.validation.fieldRequired("Description")
    ),
    type: Yup.string().required(Strings.validation.fieldRequired("Type")),
    capacity: Yup.string().required(
      Strings.validation.fieldRequired("Capacity")
    ),
    steering: Yup.string().required(
      Strings.validation.fieldRequired("Steering")
    ),
    fuelType: Yup.string().required(
      Strings.validation.fieldRequired("Fuel Type")
    ),
    price: Yup.string().required(Strings.validation.fieldRequired("Price")).min(5000,"Must be bigger then 5000"),
    year: Yup.string().required(Strings.validation.fieldRequired("Year")),
    originalPrice: Yup.string().required(
      Strings.validation.fieldRequired("Original Price")
    ),
    brandId: Yup.string().required(Strings.validation.fieldRequired("Brand")),
    categoryId: Yup.string().required(
      Strings.validation.selectionRequired("Category")
    ),
    vehicleType: Yup.string().required(
      Strings.validation.fieldRequired("Vehicle Type")
    ),
    stock: Yup.string().required(Strings.validation.fieldRequired("Stock")),
    testDrive: Yup.string().required(
      Strings.validation.fieldRequired("Test Drive")
    ),
  })
  .required(); 

export const addNewCarsSchema = Yup.object()
  .shape({
    brandId: Yup.string().required(Strings.validation.fieldRequired("Brand")),
    modelId: Yup.string().required(Strings.validation.fieldRequired("Model")),
    engineType: Yup.string().required(
      Strings.validation.fieldRequired("Engine Type")
    ),
    transmission: Yup.string().required(
      Strings.validation.fieldRequired("Transmission")
    ),
    driven: Yup.string().required(Strings.validation.fieldRequired("Driven")),
    variant: Yup.string().required(Strings.validation.fieldRequired("Variant")),
    description: Yup.string().required(
      Strings.validation.fieldRequired("Description")
    ),
    carCondition: Yup.string().required(
      Strings.validation.fieldRequired("Car Condition")
    ),
    manufacturingYear: Yup.string().required(
      Strings.validation.fieldRequired("Manufacturing Year")
    ),
    Price: Yup.string()
      .required(Strings.validation.fieldRequired("Price"))
      .test("isNumber", "Price must be a number", function(value) {
        const { createError } = this;
        if (!value) return createError({ message: Strings.validation.fieldRequired("Price") });
        const num = Number(value);
        if (isNaN(num)) return createError({ message: "Price must be a valid number" });
        if (num < 1) return createError({ message: "Price must be at least 1" });
        return true;
      }),
    color: Yup.string().required(Strings.validation.fieldRequired("Color")),
    insuranceAvailable: Yup.string().required(
      Strings.validation.selectionRequired("Insurance Availability")
    ),
    insuranceType: Yup.string().when("insuranceAvailable", {
      is: (val: string) => val === "Yes" || val === "yes",
      then: (schema) =>
        schema.required(Strings.validation.selectionRequired("Insurance Type")),
      otherwise: (schema) => schema.nullable().optional(),
    }),
    expiryDate: Yup.string().when("insuranceAvailable", {
      is: (val: string) => val === "Yes" || val === "yes",
      then: (schema) =>
        schema.required(Strings.validation.fieldRequired("Expiry Date")),
      otherwise: (schema) => schema.nullable().optional(),
    }),
    anyClaimsMade: Yup.string().required(
      Strings.validation.selectionRequired("Any Claims Made")
    ),
    usageType: Yup.string().required(
      Strings.validation.fieldRequired("Usage Type")
    ),
    rcAvailable: Yup.string().required(
      Strings.validation.selectionRequired("RC Availability")
    ),
    loanHyonthecation: Yup.string().required(
      Strings.validation.selectionRequired("Loan Hypothecation")
    ),
    accidentHistory: Yup.string().required(
      Strings.validation.selectionRequired("Accident History")
    ),
    fullServiceRecord: Yup.string().required(
      Strings.validation.selectionRequired("Full Service Record")
    ),
    isAvailableForSell: Yup.boolean(),
    extraInfo: Yup.array()
      .of(
        Yup.object().shape({
          heading: Yup.string().optional(),
          description: Yup.string().optional(),
        })
      )
      .optional(),
  })
  .required();


export const addNewProductsSchema = Yup.object().shape({
  name: fieldRequiredValidation(Strings.product.name),
  email: emailValidation(),
  phoneNo: fieldRequiredValidation(Strings.product.phone),
});
